import React, { Suspense, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Switch, Route, Redirect, RouteProps } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { I18nContextProvider } from 'common/contexts';
import { AppContextProvider } from 'common/contexts';
import { LoadScreen } from 'common/components';
import { Loader } from 'common/components/loader/loader';
import Terminal from './terminal/terminal';
import Admin from './admin/admin';
import SignIn from './auth/SignIn';
import SignUp from './auth/SignUp';
import AdminRoute from './auth/AdminRoute';
import EditorRoute from './auth/EditorRoute';
import { auth } from './firebase/config';
import * as serviceWorker from './serviceWorker';
import './i18n';
import './bootstrap.scss';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'react-toastify/dist/ReactToastify.css';
import './colors.scss';
import './index.css';
import { Routes } from 'common/enums';

const NoMatch = () => (
  <div>
    <h1>404</h1>
    Page Not Found
  </div>
);


interface PrivateRouteProps extends Omit<RouteProps, 'render'> {
  children: ReactNode;
}

const PrivateRoute = ({ children, ...rest }: PrivateRouteProps) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.currentUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: Routes.SignIn,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};

ReactDOM.render(
  <Suspense fallback={<LoadScreen />}>
    <I18nContextProvider>
      <AppContextProvider>
        <Loader>
          <ToastContainer position="bottom-left" limit={3} />
          <HashRouter>
            <Switch>
              <Route path={Routes.SignIn}>
                <SignIn />
              </Route>
              <Route path={Routes.SignUp}>
                <SignUp />
              </Route>
              <PrivateRoute path={Routes.Terminal}>
                <Terminal />
              </PrivateRoute>
              <EditorRoute path={Routes.AdminItemList}>
                <Admin />
              </EditorRoute>
              <EditorRoute path={Routes.AdminItemCreate}>
                <Admin />
              </EditorRoute>
              <EditorRoute path={Routes.AdminItemEdit}>
                <Admin />
              </EditorRoute>
              <AdminRoute path={Routes.AdminDashboard}>
                <Admin />
              </AdminRoute>
              <Redirect strict from="/" to={Routes.Terminal} />
              <Route path="*" render={NoMatch} />
            </Switch>
          </HashRouter>
        </Loader>
      </AppContextProvider>
    </I18nContextProvider>
  </Suspense>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
